"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputWithIconButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("rebass/styled-components");

var _Input = _interopRequireDefault(require("../atoms/Input"));

var _IconButton = _interopRequireDefault(require("../atoms/IconButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputWithIconButton = function InputWithIconButton(_ref) {
  var onAction = _ref.onAction,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["onAction", "icon"]);

  return _react.default.createElement(_styledComponents.Flex, {
    alignItems: "top"
  }, _react.default.createElement(_styledComponents.Box, {
    width: 9 / 10,
    mt: 2
  }, _react.default.createElement(_Input.default, props)), _react.default.createElement(_styledComponents.Box, {
    width: 1 / 10
  }, _react.default.createElement(_IconButton.default, {
    pl: 3,
    pr: 3,
    onClick: onAction,
    icon: icon
  })));
};

exports.InputWithIconButton = InputWithIconButton;
InputWithIconButton.propTypes = {
  type: _propTypes.default.string,
  error: _propTypes.default.node,
  icon: _propTypes.default.node,
  onAction: _propTypes.default.func,
  fontSize: _propTypes.default.number
};
InputWithIconButton.defaultProps = {
  type: 'text',
  error: null,
  fontSize: 1
};
var _default = InputWithIconButton;
exports.default = _default;